import React from 'react'
import ReactDOM from 'react-dom/client'
import {App} from './App'

import "@fontsource/inter"


// import './assets/sass/index.scss';
import './init/amplify';
// import './init/cloudwatch-rum';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
        .render(
            <React.StrictMode>
                <App/>
            </React.StrictMode>,
        )
